var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    { staticClass: "pa-0", attrs: { fluid: "" } },
    [
      _c(
        "v-row",
        { staticClass: "align-stretch justify-start" },
        [
          _c(
            "v-col",
            { staticClass: "pa-2 pt-0", attrs: { cols: "12", md: "8" } },
            [
              _c("LastMatchdayGamesWidget", {
                attrs: { seasonId: _vm.currentUser.league.seasonId },
                on: {
                  heightChange: function ($event) {
                    _vm.lastMatchdayGameHeight = $event
                  },
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-col",
            { staticClass: "pa-2 pt-0", attrs: { cols: "12", md: "4" } },
            [
              _c("LastPlayersSearch", {
                style: { height: _vm.lastMatchdayGameHeight + "px" },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-col",
            { staticClass: "pa-2", attrs: { cols: "12", md: "8" } },
            [
              _c("ClientsLastLogin", {
                staticClass: "elevation-2",
                on: {
                  heightChange: function ($event) {
                    _vm.chartsHeight = $event
                  },
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-col",
            { staticClass: "pa-2", attrs: { cols: "12", md: "4" } },
            [
              _c("FavoritesWidget", {
                style: { height: _vm.chartsHeight + "px" },
                attrs: { userId: _vm.currentUser.id },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _vm.currentUser.league && _vm.currentUser.league.seasonId
            ? _c(
                "v-col",
                { staticClass: "pa-2", attrs: { cols: "12", md: "8" } },
                [
                  _c("NextMatchdayGamesWidget", {
                    attrs: { seasonId: _vm.currentUser.league.seasonId },
                    on: {
                      heightChange: function ($event) {
                        _vm.nextMatchdayGameHeight = $event
                      },
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "v-col",
            { staticClass: "pa-2", attrs: { cols: "12", md: "4" } },
            [
              _c("CollectionsWidget", {
                style: { height: _vm.nextMatchdayGameHeight + "px" },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-col",
            { staticClass: "pa-2", attrs: { cols: "12" } },
            [
              _c("ReportsWidget", {
                staticStyle: { "min-height": "260px" },
                on: {
                  heightChange: function ($event) {
                    _vm.reportsHeight = $event
                  },
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-col",
            { staticClass: "pa-2", attrs: { cols: "12", md: "8" } },
            [_c("LastScoutingAnalysesWidget")],
            1
          ),
          _vm._v(" "),
          _c(
            "v-col",
            { staticClass: "pa-2", attrs: { cols: "12", md: "4" } },
            [_c("ScoutingTasksWidget")],
            1
          ),
          _vm._v(" "),
          _c(
            "v-col",
            { staticClass: "pa-2", attrs: { cols: "12", md: "8" } },
            [_c("UploadedGamesWidget")],
            1
          ),
          _vm._v(" "),
          _c(
            "v-col",
            { staticClass: "pa-2", attrs: { cols: "12", md: "4" } },
            [_c("CapturePlaylistsWidget")],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }